import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { admin, claims, errorMessage } from "../lib/api";
import { useAuth } from "../lib/auth";
import type { AgreementsStatus } from "../lib/types";

// Versiune nouă a Termenilor platformei sau a DPA-ului: proprietarul o acceptă din banner.
export default function AgreementsBanner() {
  const qc = useQueryClient();
  const { me } = useAuth();
  const q = useQuery({ queryKey: ["agreements"], queryFn: () => admin.get<AgreementsStatus>("/agreements"), staleTime: 5 * 60_000 });
  const accept = useMutation({
    mutationFn: () => admin.post<AgreementsStatus>("/agreements/accept"),
    onSuccess: (s) => qc.setQueryData(["agreements"], s),
  });
  if (!q.data?.pending) return null;
  const owner = me?.user?.role === "owner" && !claims()?.imp;
  const docs = q.data.data.filter((d) => !d.current);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-950">
      <span>
        <b>{docs.some((d) => d.accepted_version) ? "Am actualizat" : "Te rugăm să accepți"}</b>{" "}
        {docs.map((d, i) => (
          <span key={d.document}>{i > 0 && " și "}<a href={`/legal/${d.document}`} target="_blank" className="font-semibold underline">{d.title}</a></span>
        ))}
        {owner ? "." : ". Proprietarul magazinului trebuie să le accepte din panou."}
      </span>
      {owner && (
        <span className="flex items-center gap-3">
          {accept.error && <span className="text-red-600">{errorMessage(accept.error)}</span>}
          <button onClick={() => accept.mutate()} disabled={accept.isPending} className="rounded bg-amber-900/10 px-2 py-1 font-semibold hover:bg-amber-900/20">
            {accept.isPending ? "Se salvează…" : "Am citit și accept"}
          </button>
        </span>
      )}
    </div>
  );
}
